import { gql } from 'graphql-tag';

export const getMLProductRecs = gql`
  query getMLProductRecs(
    $retailerMoniker: String!
    $productIds: [String]
    $productSkus: [String]
    $orderNumber: String
    $trackingNumber: String
  ) {
    mlProductRecs(
      productIds: $productIds
      productSkus: $productSkus
      retailerMoniker: $retailerMoniker
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
    ) {
      orderNumber
      retailerMoniker
      recommendations {
        productUrl
        imageUrl
        productName
      }
    }
  }
`;

export const isGrowthBookFeatureOnQuery = gql`
  query IsGrowthBookFeatureOn(
    $project: GrowthBookProject!
    $feature: String!
    $attributes: JSONObject!
  ) {
    isGrowthBookFeatureOn(
      project: $project
      feature: $feature
      attributes: $attributes
    )
  }
`;
